import React from 'react';
import {NotEditWrapper} from "../styled-monetization/StyledMonetization";

function NotEdit({text}) {
	return (
		<NotEditWrapper>{text}</NotEditWrapper>
	);
}

export default NotEdit;